import { TournamentPrize } from "@portal-frontend-ssr/blast-api";
import { useMemo } from "react";
import { nthNumber } from "@portal-frontend-ssr/helpers";
import { generateImageUrl } from "@portal-frontend-ssr/blast-assets-api";

export const TournamentPrizesGrid = ({
  tournamentPrizes,
  tournamentTotalPrizePool,
}: {
  tournamentPrizes: TournamentPrize[];
  tournamentTotalPrizePool: string | null | undefined;
}) => {
  const groupedPrizes = useMemo(() => {
    return tournamentPrizes.reduce<{ [key: string]: TournamentPrize[] }>((r, a) => {
      r[a.prize] = r[a.prize] || [];
      r[a.prize].push(a);
      return r;
    }, {});
  }, [tournamentPrizes]);

  return (
    <>
      <h3 className="font-style-label-l3">
        Prize pool {!!tournamentTotalPrizePool && <span className="text-primary-100">{tournamentTotalPrizePool}</span>}
      </h3>
      {tournamentPrizes.length === 0 ? (
        <p className="mb-2 flex h-10 items-center justify-center rounded-small bg-background-95 px-2 text-center text-white font-style-label-l3 md:h-16 md:px-4">
          Prize pool distribution coming soon
        </p>
      ) : (
        <div className="grid auto-rows-fr grid-cols-4 gap-1">
          {Object.values(groupedPrizes)
            .sort((a, b) => a[0].positionStart - b[0].positionStart)
            .map((prizes, index) => {
              const nullPrize = prizes.find((prize) => prize.teamId === null);
              const firstPrize = nullPrize ?? prizes[0];

              return (
                <div
                  key={index}
                  className="flex flex-col items-center justify-center gap-1 rounded-small bg-background-95 py-3 sd:py-4"
                >
                  {/* POSITION */}
                  <span className="font-style-label-l5 md:font-style-label-l3">
                    {firstPrize.positionStart === firstPrize.positionEnd
                      ? `${firstPrize.positionStart}${nthNumber(firstPrize.positionStart)}`
                      : `${firstPrize.positionStart}${nthNumber(firstPrize.positionStart)} - ${firstPrize.positionEnd}${nthNumber(firstPrize.positionEnd)}`}
                  </span>
                  {/* MAIN PRIZE */}
                  <h4 className="font-style-body-b4 md:font-style-body-b1">{firstPrize.prize}</h4>
                  {/* SUB PRIZES */}
                  {firstPrize.subPrize !== null && (
                    <div className="flex flex-col gap-1">
                      {firstPrize.subPrize.map((subPrize, index) => {
                        return (
                          <span
                            key={`subprize_${index}`}
                            className="text-neutral font-style-body-b4 md:font-style-body-b3"
                          >
                            {subPrize}
                          </span>
                        );
                      })}
                    </div>
                  )}
                  {/* TEAMS */}
                  <div className="flex flex-row flex-wrap justify-center gap-3 px-4">
                    {prizes.map((prize, index) => {
                      if (!prize.teamId) return null;
                      return (
                        <img
                          key={index}
                          alt={`${prize.prize} team`}
                          src={generateImageUrl("teams", prize.teamId, {
                            format: "auto",
                            width: "20",
                          })}
                          className="size-5 object-contain md:size-6"
                        />
                      );
                    })}
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </>
  );
};
